import Chat from './chat';

export default Chat;



// WEBPACK FOOTER //
// ./src/components/cards/chat/index.js